import { heroStats, heroTags } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="border-b border-background-200/70 bg-background-100/60">
      <div className="flex flex-col gap-10 px-4 py-12 md:px-10 md:py-16 lg:flex-row lg:items-stretch lg:gap-14 lg:py-20">
        <div className="mbh-fade-up flex w-full flex-col justify-center lg:w-1/2">
          <span className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-secondary-200 bg-secondary-100/80 px-3.5 py-1.5 text-xs font-medium text-secondary-900">
            <i className="ri-live-line text-sm"></i>
            视频资源聚合 · 中文字幕
          </span>

          <h1 className="font-heading text-3xl font-semibold leading-tight text-foreground-950 md:text-5xl">
            迷人的保姆 · 在线观看入口一站汇集
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
            这里把<strong className="font-medium text-foreground-950">迷人的保姆</strong>相关的视频资源集中在一处：电影长片、剧情短片与完整版内容都可以在这里找到入口，并配有
            <strong className="font-medium text-foreground-950">迷人的保姆中文字幕</strong>
            方便理解剧情。无论你用手机还是电脑，都能快速定位想看的那个版本。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {heroTags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-background-300/70 bg-background-50 px-3 py-1.5 text-xs text-foreground-700"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#movies"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-fill text-base"></i>
              立即在线观看
            </a>
            <a
              href="#subtitle"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-closed-captioning-line text-base"></i>
              查看中文字幕版本
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <div className="font-heading text-2xl font-semibold text-primary-600">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mbh-fade-up w-full lg:w-1/2">
          <div className="relative h-full">
            <div className="relative h-[320px] w-full overflow-hidden rounded-lg md:h-[420px] lg:h-full lg:min-h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20still%20of%20an%20elegant%20sunlit%20living%20room%20with%20soft%20ivory%20walls%2C%20linen%20curtains%20and%20dried%20flowers%2C%20a%20vintage%20armchair%20and%20a%20wooden%20side%20table%2C%20amber%20and%20terracotta%20tones%2C%20artistic%20editorial%20photography%2C%20gentle%20morning%20light%2C%20calm%20refined%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1200&height=1400&seq=mbh-hero-main&orientation=portrait"
                alt="迷人的保姆 在线观看 中文字幕 主视觉"
                title="迷人的保姆 在线观看 中文字幕"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/45 via-primary-950/10 to-transparent"></div>

              <div className="absolute bottom-4 left-4 right-4 flex flex-wrap items-center gap-2">
                <span className="flex items-center gap-1.5 rounded-full bg-background-50/95 px-3 py-1.5 text-xs font-medium text-foreground-900">
                  <i className="ri-fire-line text-sm text-primary-600"></i>
                  今日热度第一
                </span>
                <span className="flex items-center gap-1.5 rounded-full bg-background-50/95 px-3 py-1.5 text-xs font-medium text-foreground-900">
                  <i className="ri-closed-captioning-line text-sm text-secondary-600"></i>
                  中文字幕已配齐
                </span>
              </div>
            </div>

            <div className="absolute -top-3 right-3 hidden rounded-lg border border-background-200 bg-background-50 px-4 py-3 lg:block">
              <div className="text-xs text-foreground-500">本页收录</div>
              <div className="font-heading text-xl font-semibold text-foreground-950">1,286 条</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}